/* eslint-disable no-underscore-dangle */

import { registerVerification, resendLink } from 'actions/user';
import { postMessageToMobileApp } from 'components/app/helpers';
import { SIGNUP_ERROR_CODES } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { IS_HYBRID_APP_SUPPORTED } from 'constants/rnApp';
import routes from 'constants/routes';
import { TRACKIER_EVENT } from 'constants/trackierEvents';
// import { loadScript } from 'helpers/dynamicScriptLoad';
import {
  checkRefCodeValidForSendingAttributionData,
  removeTrackierClickId,
} from 'helpers/analytics';
import { setUserProperty, trackMixpanelEvent } from 'helpers/mixpanel-init';
import Moengage from 'helpers/moengage';
import { addLogsToSentry } from 'helpers/sentry';
import { isTestNet } from 'helpers/utils';

import actions from './actions';

export const sendTrackierSignupEvent = userId => {
  postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.TRACKIER_EVENT, {
    eventId: TRACKIER_EVENT.SIGN_UP,
    user_id: userId,
  });
};

export const submitHandler = params => {
  const { state, appDispatch, dispatch, history, location, redirectTo, trackierClickId } =
    params;

  dispatch(actions.setLoader(true));
  appDispatch(
    registerVerification({
      otp: state.otp,
      email: state.email,
      device_id: state.device_id,
      trackier_click_id: trackierClickId,
    })
  )
    .then(response => {
      const { result } = response;
      const isSubAccount = result.is_sub_account;
      dispatch(actions.signupSuccess(result));
      Moengage.addRegisteredDate();
      Moengage.signUp({
        id: result.id,
        country: result.country,
        email: result.email,
        pageName: 'Sign-up',
        isMobileApp: window.isRNWebView,
      });
      trackMixpanelEvent('Email Verification Completed', {
        email_verification_time: new Date().toString(),
        page_name: 'Sign-up',
        email: result.email,
        is_sub_account: isSubAccount,
        type: 'email',
      });

      if (
        !IS_HYBRID_APP_SUPPORTED &&
        checkRefCodeValidForSendingAttributionData(state.referralCode)
      ) {
        postMessageToMobileApp('APPSFLYER_SIGNUP', {
          user_id: result.id,
          country: result.country,
          referralcode: state.referralCode,
        });

        if (result?.token) {
          postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.SEND_APPS_FLYER_ID, {
            token: result.token,
          });
        }
      }

      removeTrackierClickId();

      setUserProperty({
        email_verification_time: new Date().toString(),
      });
      // handled in postLoginCrossAppTokenHandlingEpic
      // postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.USER_AUTHORIZED, {
      //   user: result,
      // });

      sendTrackierSignupEvent(result.id);

      // if (window.twttr) {
      //   window.twttr.conversion.trackPid('o6krv', {
      //     tw_sale_amount: 0,
      //     tw_order_quantity: 0,
      //   });
      // }
      const investingReferralCode = 'InvestCom';
      if (state.referralCode === investingReferralCode) {
        const investingClickId = localStorage.getItem('investing_click_id');
        fetch(
          `https://us-central1-madrid-investing.cloudfunctions.net/PostbackCloudFunciton/?token=YWR2ZXJpc2VyX2FmZmlsYXRpb25fdXJs&advertiser=Delta%20Exchange&brand=Delta%20Exchange&model=CPL&affiliate_id=${investingReferralCode}&offer_id=&user_id=${result.id}&event_type=Lead&subID=${investingClickId}
            `
        ).catch(() => {});
      }

      try {
        if (window._tfa) {
          window._tfa.push({
            notify: 'event',
            name: 'web_signup',
            id: 1465044,
          });
        }
      } catch (error) {
        console.error(error);
      }

      // Normal Account - Redirect to markets if not on mobile device.
      // Sub Account - Redirect to markets always.
      // 500ms delay before redirect to let SignupUserTracking Component render.
      if (isSubAccount) {
        setTimeout(() => {
          history.push({
            pathname: routes.webAppHome,
            state: {
              showRegisterSuccessModal: false, // RegisterSuccessModal not shown for SubAccount.
            },
          });
        }, 500);
      } else {
        setTimeout(() => {
          if (location?.state?.showScalpingPopup) {
            history.push(location.state.from.pathname, { showScalpingPopup: true });
          } else {
            history.push({
              pathname: redirectTo,
              state: {
                showRegisterSuccessModal: !isTestNet(), // RegisterSuccessModal not shown if TestNet.
              },
            });
          }
        }, 500);
      }
    })
    .catch(error => {
      const errorObj = error.response.body.error;

      dispatch(
        actions.signupFailure({
          errorCode: errorObj.code,
          errorContext: errorObj.context,
        })
      );

      if ([SIGNUP_ERROR_CODES.includes(errorObj.code)]) {
        addLogsToSentry(
          {
            otp: state.otp,
            email: state.email,
            device_id: state.device_id,
            trackier_click_id: trackierClickId,
            errorObj,
          },
          'Signup Handled Error'
        );
      }
    });
};

export const resendOtpHandler = params => {
  const { state, appDispatch, dispatch, timerRef } = params;
  appDispatch(resendLink(state.email))
    .then(() => {
      trackMixpanelEvent(MIXPANEL_EVENT_NAMES.SIGN_UP.RESEND_EMAIL_CODE, {
        resend_email_time: new Date().toString(),
        page_name: 'Sign-up',
        type: 'Register',
      });
      if (timerRef.current) {
        timerRef.current.reset();
        timerRef.current.start();
      }
      dispatch(actions.resendEmailOTPSuccess());
    })
    .catch(error => {
      const errorObj = error.response.body.error;
      dispatch(
        actions.resendEmailOTPFailure({
          errorCode: errorObj.code,
        })
      );
    });
};
